import { CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const industries = [{
  name: "Main Office: 1200 Sterling Plaza, Suite 500"
}, {
  name: "Direct Line: (555) 820-4000"
}, {
  name: "Client Support: (555) 820-4001"
}, {
  name: "Hours: Mon - Fri, 8:00 AM - 6:00 PM"
}];
export default function ReachOurOffices() {
  return <section data-section-id="258356" id="reach-our-offices" className="bg-background text-foreground py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {}
          <div className="relative h-[400px] sm:h-[500px] lg:h-[700px] w-full rounded-md overflow-hidden shadow-2xl">
            <div className="absolute inset-0 bg-primary/5 mix-blend-multiply z-10"></div>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687512/img/sterling_law_map_dark.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687512/img/sterling_law_map_dark.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687512/img/sterling_law_map_dark.png-wvc-sizes" alt="Sterling Law Associates Office Location Map" className="absolute inset-0 w-full h-full object-cover grayscale contrast-100 brightness-50" loading="lazy" />
          </div>

          {}
          <div className="flex flex-col justify-center space-y-10">
            <div className="space-y-4">
              <h2 className="text-5xl sm:text-6xl lg:text-7xl font-default font-bold leading-[1.1] tracking-tight text-foreground">
                Reach.<br />
                Consult.<br />
                Resolve.<br />
                Succeed.
              </h2>
              <p className="text-xl md:text-2xl text-muted-foreground max-w-lg font-default mt-6">
                Our headquarters are located in the heart of the financial district, providing elite legal counsel with architectural precision.
              </p>
            </div>

            <div className="space-y-6">
              <h3 className="text-lg font-mono font-semibold text-secondary uppercase tracking-widest">
                Office Information:
              </h3>
              <ul className="space-y-4">
                {industries.map((industry, i) => <li key={i} data-index={i} className="flex items-start gap-4">
                    <CircleCheck className="size-6 text-primary shrink-0 mt-0.5" />
                    <span className="text-lg md:text-xl font-medium text-foreground/90 font-default">
                      {industry.name}
                    </span>
                  </li>)}
              </ul>
            </div>

            <div className="pt-4">
              <Button asChild size="lg" className="text-base font-mono font-semibold bg-primary hover:bg-primary/90 text-primary-foreground rounded-md">
                <Link to="/ContactPage">
                  Schedule Consultation
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}